<template>
  <div class="theme-switcher">
    <select v-model="currentTheme" @change="setTheme" class="sel-the">
      <option value="light">白天</option>
      <option value="dark">黑夜</option>
      <option value="os">系统</option>
    </select>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';

const currentTheme = ref(localStorage.getItem('theme') || 'os');

const setTheme = (event) => {
  const theme = event.target.value;
  localStorage.setItem('theme', theme);
  document.documentElement.setAttribute('data-theme', theme);
};

const getSystemTheme = () => {
  let theme = localStorage.getItem('theme');
  if (!theme) {
    const darkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
    theme = darkMode ? 'dark' : 'light';
  }
};

onMounted(() => {
  document.documentElement.dataset.theme = currentTheme.value === 'os' ? getSystemTheme() : currentTheme.value;
});

watch(currentTheme, (newTheme) => {
  document.documentElement.dataset.theme = newTheme === 'os' ? getSystemTheme() : newTheme;
});
</script>

<style scoped>
.theme-switcher {
  background-color: var(--background-color);
  color: var(--color);
}

.theme-switcher select {
  background-color: var(--background-color);
  color: var(--color);
}

.theme-switcher select option {
  background-color: var(--background-color);
  color: var(--color);
}

.sel-the {
  font-size: var(--font-size);
  font-family: var(--font-family);
}
</style>